import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { GridFooterContainer, GridPagination } from "@mui/x-data-grid";
import { useTheme } from "../../ThemeContext";


export const CustomNoRowsOverlay = () => {
  const { isDarkMode } = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%", // Ensure it has a visible height
        fontSize: "16px",
        fontWeight: "bold",
        // color: "#888",
        // backgroundColor: "#f0f0f0", // Temporary background to debug
        backgroundColor: isDarkMode ? "#272626" : "#f0f0f0",
        color: isDarkMode ? "white" : "#888",
      }}
    >
      No data found
    </Box>
  );
};

export const CustomFooter = ({ totalLogHours }) => {
  return (
    <GridFooterContainer>
      {/* Left side - Display Total Log Hours */}
      <Box sx={{ flex: 1, paddingLeft: 2 }}>
        <Typography variant="body2">
          <strong>Total Log Hours:</strong> {totalLogHours || "00:00"}
        </Typography>
      </Box>
      <GridPagination />
    </GridFooterContainer>
  );
};
